import { SafeImage } from "@/components/ui/SafeImage";
import { resolveStationLogo } from "@/lib/station-logos";

type StationLike = {
  name: string;
  stationLogo?: string | null;
};

export function StationBrandMark({
  station,
  size = 44,
}: {
  station: StationLike;
  size?: number;
}) {
  const logo = resolveStationLogo(station);

  if (logo) {
    return (
      <SafeImage
        src={logo}
        alt={station.name}
        width={size * 3}
        height={size}
        className="h-auto w-auto shrink-0 object-contain"
        style={{ maxHeight: size }}
      />
    );
  }

  return (
    <span className="shrink-0 text-sm font-bold text-muted">
      {station.name.slice(0, 2).toUpperCase()}
    </span>
  );
}
